import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'
import { ClipLoader } from 'react-spinners'
import { useImage } from '@open-tender/utils'
import { BgImage } from 'components'

const HeroSiteView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-height: 64rem;
  background-color: ${(props) => props.theme.bgColors.dark};
`

const HeroSiteBackgroundImage = styled(BgImage)`
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  animation: fade-in 0.5s ease-in-out 0s forwards;
`

const HeroSiteLoading = styled.div`
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

const HeroSiteContent = styled.div`
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding: ${(props) => props.theme.layout.margin}
    ${(props) => props.theme.layout.padding};
  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    padding: ${(props) => props.theme.layout.marginMobile}
      ${(props) => props.theme.layout.paddingMobile};
  }
`

const HeroSite = ({
  imageUrl,
  style,
  children,
}: {
  imageUrl?: string
  style?: React.CSSProperties
  children: JSX.Element | JSX.Element[]
}) => {
  const theme = useTheme()
  const { hasLoaded, hasError } = useImage(imageUrl)
  const isLoading = !hasLoaded && !hasError
  const bgStyle =
    imageUrl && !isLoading
      ? { ...style, backgroundImage: `url(${imageUrl}` }
      : undefined
  return (
    <HeroSiteView>
      {isLoading ? (
        <HeroSiteLoading>
          <ClipLoader size={30} loading={true} color={theme.bgColors.light} />
        </HeroSiteLoading>
      ) : (
        <HeroSiteBackgroundImage style={bgStyle} />
      )}
      <HeroSiteContent>{children}</HeroSiteContent>
    </HeroSiteView>
  )
}

export default HeroSite
